module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/activities.json
// module id = 352
// module chunks = 208841573973569